import CounterProgress from './counters-components/CounterProgress';
import DateTime from './counters-components/DateTime';
import CounterDelayed from './counters-components/CounterDelayed';
import CounterCompleted from './counters-components/CounterCompleted';
import { useEffect } from 'react';
import { Grid } from '@mui/material';

function HomeTab(props) {
  const { progress, delayed, completed } = props.counters;

  const { progressTickets, delayedTickets, completedTickets } = props;

  useEffect(() => {
    const elProgress = document.getElementById('progress');
    const elDelayed = document.getElementById('delayed');
    const elCompleted = document.getElementById('completed');
    const onProgress = () => props.goTo('tableProgress');
    const onDelayed = () => props.goTo('tableDelayed');
    const onCompleted = () => props.goTo('tableCompleted');

    elProgress?.addEventListener('click', onProgress);
    elDelayed?.addEventListener('click', onDelayed);
    elCompleted?.addEventListener('click', onCompleted);

    return () => {
      elProgress?.removeEventListener('click', onProgress);
      elDelayed?.removeEventListener('click', onDelayed);
      elCompleted?.removeEventListener('click', onCompleted);
    };
  }, [props.goTo]);

  const container = {
    show: {
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  const item = {
    hidden: { opacity: 0, y: 20 },
    show: { opacity: 1, y: 0 },
  };

  return (
    <Grid container direction='row' justifyContent='space-between' alignItems='center' spacing={2}>
      <Grid item xs={12} md={6} className='mt-8'>
        <CounterProgress counter={progress} tickets={progressTickets} />
      </Grid>
      <Grid item xs={12} md={6} className='mt-8'>
        <CounterDelayed counter={delayed} tickets={delayedTickets} />
      </Grid>
      <Grid item xs={12} md={6} className='mt-8'>
        <CounterCompleted counter={completed} tickets={completedTickets} />
      </Grid>
      <Grid item xs={12} md={6} className='mt-8'>
        <DateTime />
      </Grid>
    </Grid>
  );
}

export default HomeTab;
